import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

const useGARouteChangeTracker = (key, options) => {   
  if (options) {
    ReactGA.initialize(key, options);
  }  else {
    ReactGA.initialize(key);
  }

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    ReactGA.set({ page: path });
    ReactGA.pageview(path);
  }, [location]);

  return null;
};

export default useGARouteChangeTracker;